import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/th/faq")({
  beforeLoad: () => {
    throw redirect({ to: "/th", replace: true });
  },
});
